const CUSTOM_SELECT_CLASSNAME = 'custom-select';
const CUSTOM_SELECT_OPTION_CLASSNAME = 'custom-select__option';
const ORIGINAL_SELECT_SELECTOR = '.custom-select__original-select';
const SELECTED_VALUE_SELECTOR = '.custom-select__selected-value';
const CUSTOM_SELECT_OPTIONS_SELECTOR = '.custom-select__options';
const CUSTOM_SELECT_OPTION_SELECTOR = '.' + CUSTOM_SELECT_OPTION_CLASSNAME;
const IS_SELECTED_MODIFIER = '--is-selected';
const IS_FOCUSED_MODIFIER = '--is-focused';

function toggleCustomSelect($customSelect) {
    "use strict";

    $customSelect.toggleClass(CUSTOM_SELECT_CLASSNAME + IS_FOCUSED_MODIFIER);

    if ($customSelect.hasClass(CUSTOM_SELECT_CLASSNAME + IS_FOCUSED_MODIFIER)) {
        $(document.body).on('click.hideSelectOptions', function(evt) {
            if ($(evt.target).isElementInside($customSelect)) {
                toggleCustomSelect($customSelect);
            }
        });
    } else {
        $(document.body).off('click.hideSelectOptions');
    }
}

(function($) {
    "use strict";

    $.fn.customSelect = function() {
        return this.each((index, customSelectNode) => {
            var $customSelect, $origSelect, $selectedValue, $customOptionsContainer, $customOptions;

            $customSelect = $(customSelectNode);
            $origSelect = $customSelect.find(ORIGINAL_SELECT_SELECTOR);
            $selectedValue = $customSelect.find(SELECTED_VALUE_SELECTOR);
            $customOptionsContainer = $customSelect.find(CUSTOM_SELECT_OPTIONS_SELECTOR);
            $customOptions = $customSelect.find(CUSTOM_SELECT_OPTION_SELECTOR);

            $customOptionsContainer.on('click', CUSTOM_SELECT_OPTION_SELECTOR, (evt) => {
                var $clickedOption, value;

                $clickedOption = $(evt.target);
                value = $clickedOption.attr('data-value');
                $origSelect.val(value).trigger('change');
                $selectedValue.text($clickedOption.text());
                $customOptions
                    .removeClass(CUSTOM_SELECT_OPTION_CLASSNAME + IS_SELECTED_MODIFIER)
                    .filter('[data-value="' + value + '"]')
                    .addClass(CUSTOM_SELECT_OPTION_CLASSNAME + IS_SELECTED_MODIFIER);

                toggleCustomSelect($customSelect);
            });

            $selectedValue.on('click', (e) => {
                e.stopPropagation();
                toggleCustomSelect($customSelect);
            });
        });
    };
})(jQuery);